import { handleActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = ''

export default handleActions(
  {
    [rawActions.updateGeneralFilter](state, action) {
      return action.payload
    },
    [rawActions.clearGeneralFilter](state, action) {
      return defaultState
    },
    [rawActions.resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)
